import IntimacoesAPI from '../../api/intimacoes';

const state = {
  records: [],
  meta: {
    total_count: 0,
    current_page: 1,
    total_pages: 1,
    unread_count: 0,
    favorites_count: 0,
  },
  summary: {
    unread_count: 0,
    total_count: 0,
    calendar_summary: {},
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

const getters = {
  getIntimacoes($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getSummary($state) {
    return $state.summary;
  },
  getUnreadCount($state) {
    return $state.meta.unread_count || $state.summary.unread_count || 0;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await IntimacoesAPI.get(params);
      commit('SET_RECORDS', response.data.intimacoes || []);
      commit('SET_META', response.data.meta || {});
    } catch (error) {
      console.error('[Intimacoes] Fetch error:', error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async toggleRead({ commit }, id) {
    try {
      const response = await IntimacoesAPI.toggleRead(id);
      commit('UPDATE_RECORD', response.data);
    } catch (error) {
      console.error('[Intimacoes] toggleRead error:', error);
    }
  },

  async toggleFavorite({ commit }, id) {
    try {
      const response = await IntimacoesAPI.toggleFavorite(id);
      commit('UPDATE_RECORD', response.data);
    } catch (error) {
      console.error('[Intimacoes] toggleFavorite error:', error);
    }
  },

  async bulkUpdate({ commit, dispatch }, { ids, is_read, is_favorite }) {
    try {
      await IntimacoesAPI.bulkUpdate({ ids, is_read, is_favorite });
      dispatch('getSummary');
    } catch (error) {
      console.error('[Intimacoes] bulkUpdate error:', error);
    }
  },

  async getSummary({ commit }) {
    try {
      const response = await IntimacoesAPI.getSummary();
      commit('SET_SUMMARY', response.data || {});
    } catch (error) {
      console.error('[Intimacoes] getSummary error:', error);
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  SET_RECORDS($state, records) {
    $state.records = records;
  },
  SET_META($state, meta) {
    $state.meta = meta;
  },
  SET_SUMMARY($state, summary) {
    $state.summary = summary;
  },
  UPDATE_RECORD($state, updated) {
    const index = $state.records.findIndex(r => r.id === updated.id);
    if (index !== -1) {
      const old = $state.records[index];
      // Adjust unread counter optimistically
      if (old.is_read !== updated.is_read) {
        $state.meta.unread_count += updated.is_read ? -1 : 1;
        if ($state.meta.unread_count < 0) $state.meta.unread_count = 0;
      }
      $state.records.splice(index, 1, updated);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
